import { SubscriptionPeriod } from '@anm/api/modules/subscription';
import Button from '@anm/components/buttons/Button';
import CancelBlock from '@anm/components/subscription/current-plan/CancelBlock';
import CardPlan from '@anm/components/subscription/current-plan/CardPlan';
import { LinkContext } from '@anm/contexts/LinkContext';
import getPeriodName from '@anm/helpers/subscription/getPeriodName';
import { useContext, FC } from 'react';

import { LinkWrapper } from './Wrapper';

export type CurrentCancelPlanProps = {
  date: number;
  period: SubscriptionPeriod;
  planName: string;
  upgradeRoute: string;
};

const CurrentCancelPlan: FC<CurrentCancelPlanProps> = ({
  date,
  period,
  planName,
  upgradeRoute
}) => {
  const { Link } = useContext(LinkContext);

  return (
    <CardPlan plan={planName} periodName={getPeriodName(period)}>
      <CancelBlock date={date} />
      <LinkWrapper>
        <Link route={upgradeRoute}>
          <Button size="medium" variant="light-blue">
            Upgrade
          </Button>
        </Link>
      </LinkWrapper>
    </CardPlan>
  );
};

export default CurrentCancelPlan;
